import TagIds from '~/constants/common/tagIds';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export default function generateEvTaxCreditLink(): string {
  return `${generateSearchLinkFilter({
    filters: { tagIds: [String(TagIds.EvTaxCreditMayBeEligible)] }
  })}&p_bnr=ev`;
}
